export default __webpack_public_path__ + "static/media/Swim_Laps_16_9.75066a81.png";